import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative w-full min-h-screen bg-gradient-to-br from-jazugas-blue via-blue-700 to-blue-900 overflow-hidden" data-id="element-14">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-15">
        <div className="absolute inset-0" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }} data-id="element-16"></div>
      </div>

      <div className="relative max-w-6xl mx-auto px-4 py-12 flex flex-col items-center justify-center min-h-screen" data-id="element-17">
        {/* Logo */}
        <motion.div className="mb-12" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-18">
          <img src="https://cdn.magicpatterns.com/uploads/id3CX4wVnk64xtH8cNPcvd/Logo_Jazugas.png" alt="JAZUGAS Logo" className="h-24 md:h-32 w-auto" data-id="element-19" />
        </motion.div>

        {/* Main Content */}
        <div className="text-center space-y-8 max-w-4xl" data-id="element-20">
          <motion.h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-21">
            Instaladores de Gas LP en Costa Rica:{' '}
            <span className="text-jazugas-yellow" data-id="element-22">
              trabajá por servicios con JAZUGAS
            </span>
          </motion.h1>

          <motion.p className="text-xl md:text-2xl text-blue-100 leading-relaxed max-w-3xl mx-auto" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} data-id="element-23">
            Buscamos instaladores con experiencia para trabajar por servicios
            profesionales (no planilla). Coordinación central y asignación por
            zona.
          </motion.p>

          <motion.div className="pt-8" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} data-id="element-24">
            <motion.a href="https://wa.me/50689925929" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-10 py-5 bg-jazugas-yellow text-jazugas-black text-lg font-bold rounded-xl hover:bg-opacity-90 transition-all duration-300 shadow-2xl hover:shadow-jazugas-yellow/50" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} aria-label="Aplicar por WhatsApp al número 8992-5929" data-id="element-25">
              <svg className="w-7 h-7 mr-3" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-26">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-27" />
              </svg>
              Aplicar por WhatsApp
            </motion.a>
          </motion.div>
        </div>

        {/* Scroll Indicator */}
        <motion.div className="absolute bottom-8 left-1/2 transform -translate-x-1/2" initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 1,
        repeat: Infinity,
        repeatType: 'reverse'
      }} data-id="element-28">
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-29">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" data-id="element-30" />
          </svg>
        </motion.div>
      </div>
    </section>;
}